/**
 * This file sets up environment variables programmatically
 * since we can't directly modify .env files
 */

// This is a hacky way to set environment variables at runtime
// Only use this in development, not in production
if (process.env.NODE_ENV === 'development') {
  // Define our environment variables
  window.REACT_APP_API_URL = 'http://localhost:5004';
  window.REACT_APP_DISABLE_HOST_CHECK = true;
  window.WDS_SOCKET_HOST = 'localhost';
  window.WDS_SOCKET_PORT = '0';
  
  // Override webpack DevServer settings if possible
  if (window.webpackHotDevClient && window.webpackHotDevClient.options) {
    window.webpackHotDevClient.options.webSocketURL = {
      hostname: 'localhost',
      protocol: window.location.protocol === 'https:' ? 'wss' : 'ws',
    };
  }
  
  // Override webpack dev server allowedHosts
  if (window.__webpack_dev_server_client__) {
    try {
      window.__webpack_dev_server_client__.allowedHosts = ['localhost', '127.0.0.1', 'all'];
    } catch (e) {
      console.warn('Could not set webpack dev server allowedHosts:', e);
    }
  }
  
  // Log environment setup
  console.log('Environment variables configured programmatically');
  console.log('API URL:', window.REACT_APP_API_URL);
  console.log('WDS Socket Host:', window.WDS_SOCKET_HOST);
  console.log('WDS Socket Port:', window.WDS_SOCKET_PORT);
  console.log('Disable Host Check:', window.REACT_APP_DISABLE_HOST_CHECK);
}

const setupEnvModule = {};
export default setupEnvModule; 